module.exports = new __parcel__URL__("Lego.09745725.avif").toString();